import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from 'contexts/AuthContext';
import MentorshipDashboard from 'pages/Mentorship/MentorshipDashboard';

type MentorshipRole = 'mentor' | 'mentee' | 'cohort_director' | 'cohort_admin';

const getActiveRoles = (cohorts?: { is_active: boolean; role: MentorshipRole }[]) =>
  (cohorts ?? [])
    .filter((c) => c.is_active)
    .map((c) => c.role);

export const MentorshipLandingRoute: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();
  const activeRoles = getActiveRoles(user?.cohorts as any);

  if (!activeRoles.length) {
    return <Navigate to="/home" replace />;
  }

  if (activeRoles.includes('cohort_director') || activeRoles.includes('cohort_admin')) {
    return (
      <Navigate
        to={{
          pathname: '/mentorship/director',
          search: location.search,
          hash: location.hash,
        }}
        replace
      />
    );
  }

  return <MentorshipDashboard />;
};

export const MentorshipRoleRoute: React.FC<{
  allowedRoles: MentorshipRole[];
  children: React.ReactNode;
}> = ({ allowedRoles, children }) => {
  const { user } = useAuth();
  if (user?.is_staff) {
    return <>{children}</>;
  }

  const activeRoles = getActiveRoles(user?.cohorts as any);

  if (!activeRoles.length) {
    return <Navigate to="/home" replace />;
  }

  const hasRole = activeRoles.some((role) => allowedRoles.includes(role));
  if (!hasRole) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};
